/*jshint esversion: 6 */

$(window).on('load', function () {
    var startInterstitials = document.getElementsByClassName("startInterstitial");
    if (startInterstitials.length > 0) {
        for (let i = 0; i < startInterstitials.length; i++) {
            var interstitialId = startInterstitials[i].value;
            $('#interstitialModal_' + interstitialId).modal('show');
        }
    }
});